import { OnInit } from '@angular/core';
import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { ActiveSuppliers } from '../Models/ActiveClasses';
import { AirlineMasterProperties } from '../Models/AirlineMasterProperties';
import { AirlinePassengerCriteria, SupplierPassengerCriteria } from '../Models/MasterPassengerInfoProperties';

//import { faL } from '@fortawesome/free-solid-svg-icons';
//import { TicketSuppliersAccessCodeProperties } from '../Models/GroupTicketProperties';
//import { AirportProperties } from '../Models/AirportProperties';
//import { ByAirlinesRateOfExchangeProperties, BySectorRateOfExchangeProperties, LocationByROE, RateOfExchangeProperties, ROEDates, TripType, TypeOfRateOfExchangeFunction } from '../Models/RateOfExchangeProperties';
//import { RevenueManagementAirports, Supplier_OficeID } from '../Models/RevenueManagementProperties';
//import { AirportService } from '../Services/airport.service';
//import { GroupTicketService } from '../Services/groupTicket.service';

import { AirlineMasterService } from '../Services/airline-master.service';
import { MasterPassengerInfoService } from '../Services/master-passenger-info.service';
import { RevenueManagementService } from '../Services/revenue-management.service';

@Component({
  selector: 'app-master-passenger-info',
  templateUrl: './master-passenger-info.component.html',
  styleUrls: ['./master-passenger-info.component.css']
})
export class MasterPassengerInfoComponent {




  /**  ctor **/
  constructor(private revenueService: RevenueManagementService, private service: MasterPassengerInfoService, private airlineservice: AirlineMasterService, private messageservice: MessageService, private router: Router) {

  }

  allValid: boolean = false;
  addAirlines: boolean = false;
  loader: boolean = false;
  //loadermessage: string = "";
  //rateofexhcnageenum = new TypeOfRateOfExchangeFunction();
  //minDate: string;
  supplierList: ActiveSuppliers[] = [];
  //airportProperties: AirportProperties[] = [];
  //officeidList: TicketSuppliersAccessCodeProperties[] = [];
  //officeidListForBind: TicketSuppliersAccessCodeProperties[] = [];
  supplierPassengerCriteria = new SupplierPassengerCriteria();
  supplierPassengerCriteriaExisitINdb: SupplierPassengerCriteria[] = [];
  airlinesList: AirlineMasterProperties[] = [];
  update: boolean = false;
  supplierCriteriaSubmission: boolean = false;
  // officeid: string = "";
  namebutton: string = "";
  // currency: string = "";
  ngOnInit() {
    //this.currency = localStorage.getItem('AgencyCurrency');
    //let SupplierCriteriaId = localStorage.getItem("SupplierCriteriaId");
    let TypeCriteria = localStorage.getItem("TypeCriteria");
    //let agencyid = localStorage.getItem("AgencyId");
    //this.getDataAirportAll();

    this.getSuppliers();
    this.GetAirlineData();

    //const currentDate = new Date();
    //const formattedCurrentDate = currentDate.toISOString().split('T')[0];
    //this.minDate = formattedCurrentDate;

    if (TypeCriteria == "Create") {
      this.namebutton = "Create";
      this.getAllSuppliersCriteria();

    }
    else if (TypeCriteria == "Update") {
      this.loader = true;
      this.addAirlines = true;

      this.namebutton = "Update";

      this.service.GetSupplierCriteriaByID(localStorage.getItem("SupplierCriteriaId")).subscribe((data) => {

        this.supplierPassengerCriteria = data;

        //this.officeid = data.officeIDs;
        // this.changeSupplier();
        this.update = true;
        this.loader = false;
      })


    }
  }

  //ParseDate = (dateString: string): string => {
  //  if (dateString) {
  //    return dateString;
  //  }
  //  return null;
  //}

  getAllSuppliersCriteria() {
    this.service.GetAllSupplierMasterPassengerInfo().subscribe((data) => {
      this.supplierPassengerCriteriaExisitINdb = data;

    });
  }

  checkCriteria(): boolean {
    this.allValid = true;

    try {
      if (!this.supplierPassengerCriteria.byAirlines || this.supplierPassengerCriteria.byAirlines.length === 0) {
        this.messageservice.add({ severity: 'error', summary: 'Required', detail: 'Please add Airlines!' });
        this.allValid = false;
        return this.allValid;
      }

      this.allValid = this.supplierPassengerCriteria.byAirlines.every(airline => {
        return airline.isDeleted || (airline.title && airline.firstName && airline.lastName && airline.gender);
      });

    } catch (e) {
      console.log("There is some error");
      this.allValid = false;
    }

    return this.allValid;
  }



  //getDataAirportAll() {
  //  this.airportService.GetAllAirport().subscribe((data) => {
  //    this.airportProperties = data;

  //  });
  //}

  getSuppliers() {
    this.revenueService.GetRevenueManagementSupplierByParent(localStorage.getItem("AgencyId")).subscribe((result) => {
      this.supplierList = result;

    });
  }




  supplierAdded: boolean = false;

  //changeSupplier() {

  //  this.supplierPassengerCriteria = new SupplierPassengerCriteria();
  //  this.supplierPassengerCriteria.byAirlines = [];
  //  this.officeidListForBind = [];
  //  this.officeidList = [];
  //  this.groupservice.GetTicketAccessCode(this.supplierPassengerCriteria.supplier).subscribe(data => {
  //    this.officeidListForBind = data;

  //    let curr = localStorage.getItem("AgencyCurrency");
  //    if (this.officeidListForBind.length > 0) {
  //      for (let i = this.officeidListForBind.length - 1; i >= 0; i--) {
  //        if (curr == this.officeidListForBind[i].currencyName) {

  //          // Remove the item from the array using splice
  //          this.officeidListForBind.splice(i, 1);
  //        }
  //      }
  //    }
  //    this.supplierAdded = true;
  //  });
  // }

  AddAirline() {
    if (this.supplierPassengerCriteria.byAirlines == undefined) {
      this.addAirlines = true;
      this.supplierPassengerCriteria.byAirlines = [];
    }
    let obj = new AirlinePassengerCriteria();
    obj.airlines = [];
    this.supplierPassengerCriteria.byAirlines.push(obj);
  }

  AddCriteria(airline) {

    this.supplierPassengerCriteria.byAirlines[airline].applyCriteria = true;

    //this.supplierPassengerCriteria.byAirlines[airline] = [];
    //this.supplierPassengerCriteria.byAirlines[airline].title = true;
    //this.supplierPassengerCriteria.byAirlines[airline].firstName = true;
    //this.supplierPassengerCriteria.byAirlines[airline].lastName = true;
    //this.supplierPassengerCriteria.byAirlines[airline].gender = true;


  }

  ShowOptionalCriteria(airline, hide: boolean) {

    this.supplierPassengerCriteria.byAirlines[airline].showOptionalValues = hide;

  }

  //AddSector(airline) {
  //  if (this.supplierPassengerCriteria.byAirlines[airline].bySectorList.length == 0) {
  //    this.supplierPassengerCriteria.byAirlines[airline].isBySector = true;
  //  }
  //  let obj = new BySectorRateOfExchangeProperties();
  //  obj.bookingDate = new ROEDates();
  //  obj.travelingDate = new ROEDates();
  //  obj.locationExclusuion = new LocationByROE();
  //  obj.locationInclusuion = new LocationByROE();
  //  obj.tripTypes = new TripType();
  //  this.supplierPassengerCriteria.byAirlines[airline].bySectorList.push(obj);
  //}

  //deleteSector(airline, sector) {
  //  if (this.supplierPassengerCriteria.byAirlines[airline].bySectorList.length > 0) {
  //    if (this.supplierPassengerCriteria.byAirlines[airline].bySectorList[sector].sectorROEID > 0) {

  //      this.supplierPassengerCriteria.byAirlines[airline].bySectorList[sector].isDeleted = true;

  //    }
  //    else {

  //      this.supplierPassengerCriteria.byAirlines[airline].bySectorList.splice(sector, 1);

  //    }
  //  }
  //  if (this.supplierPassengerCriteria.byAirlines[airline].bySectorList.length == 0) {
  //    this.supplierPassengerCriteria.byAirlines[airline].isBySector = false;
  //  }
  //}

  deleteairline(airline) {
    if (this.supplierPassengerCriteria.byAirlines[airline].airLinePassMasterCriteriaId > 0) {

      this.supplierPassengerCriteria.byAirlines[airline].isDeleted = true;

    }
    else {
      //this.supplierPassengerCriteria.byAirlines[airline].isDeleted = true;
      this.supplierPassengerCriteria.byAirlines.splice(airline, 1);

    }
  }

  GetAirlineData() {
    this.airlineservice.getAirlinesData().subscribe((data) => {
      if (data.length > 0) {

        this.airlinesList = data;
      }
    })
  }

  onPassportChange(airline: number) {

    if (this.supplierPassengerCriteria.byAirlines[airline].passport) {
      this.supplierPassengerCriteria.byAirlines[airline].passportExpiryDate = true;
    } else {
      this.supplierPassengerCriteria.byAirlines[airline].passportExpiryDate = false;
    }

  }


  onPassportExpiryChange(airline: number) {

    if (this.supplierPassengerCriteria.byAirlines[airline].passportExpiryDate) {
      this.supplierPassengerCriteria.byAirlines[airline].passport = true;
    } else {
      this.supplierPassengerCriteria.byAirlines[airline].passport = false;
    }

  }

  SubmitData = (passCriteriaForm: any): boolean => {
    this.supplierCriteriaSubmission = true;
    if (passCriteriaForm.invalid) {
      this.messageservice.add({ severity: 'error', summary: 'Required', detail: 'Fields are Required' });


      return false;
    }

    if (!this.checkCriteria()) {
      // this.messageservice.add({ severity: 'error', summary: 'Required', detail: 'Fields are Required' });
      return false;
    }


    //if (!this.rateOfExchangeRoeCheck(this.supplierPassengerCriteria.byDefaultROE)) {
    //  return false;
    //}

    //if (this.supplierPassengerCriteria.isByAirlines) {
    //  for (let a = 0; a < this.supplierPassengerCriteria.byAirlines.length; a++) {
    //    if (!this.airlineRoeCheck(this.supplierPassengerCriteria.byAirlines[a].byDefaultROE, a)) {
    //      return false;
    //    } else {
    //      if (this.supplierPassengerCriteria.byAirlines[a].isBySector) {
    //        for (let s = 0; s < this.supplierPassengerCriteria.byAirlines[a].bySectorList.length; s++) {
    //          if (!this.sectorRoeCheck(this.supplierPassengerCriteria.byAirlines[a].bySectorList[s].byDefaultROE, a, s)) {
    //            return false;
    //          }
    //        }
    //      }
    //    }
    //  }
    //}

    //this.loader = true;
    //if (this.update) {
    //  this.loadermessage = "Updating the Data!";
    //this.service.UpdateRateOfExchange(this.supplierPassengerCriteria).subscribe((data) => {
    //  if (data.isSaved) {

    //    this.messageservice.add({ severity: 'success', summary: 'Success', detail: 'Updated Successfully!' });
    //    this.router.navigateByUrl("/RateOfExchangeList");

    //  }
    //  else {
    //    this.messageservice.add({ severity: 'error', summary: 'Error', detail: data.errorInfo });
    //  }
    //  this.loader = false;
    //})
    //}
    //else {
    //  if (!this.ChecktheCriteriaExistOrNot()) {
    //    this.loader = false;
    //    return false;
    //  }
    //  this.loadermessage = "Saving the Data!";
    //  this.service.CreateRateOfExchange(this.supplierPassengerCriteria).subscribe((data) => {
    //    if (data.isSaved) {
    //      this.messageservice.add({ severity: 'success', summary: 'Success', detail: 'Created Successfully!' });
    //      this.router.navigateByUrl("/RateOfExchangeList");
    //    }
    //    else {
    //      this.messageservice.add({ severity: 'error', summary: 'Error', detail: data.errorInfo });
    //    }
    //    this.loader = false;
    //  })
    //}

    this.loader = true;
    if (this.update) {
      this.service.UpdateSuppMasterPassengerCriteria(this.supplierPassengerCriteria).subscribe((data) => {
        if (data) {
          this.messageservice.add({ severity: 'success', summary: 'Success', detail: 'Updated Successfully!' });
          this.router.navigateByUrl("/MasterSupplierPassengerlist");
        }
        else {
          this.messageservice.add({ severity: 'error', summary: 'Error', detail: "Something went wrong" });
        }
        this.loader = false;
      })
    }

    else {
      if (!this.ChecktheCriteriaExistOrNot()) {
        this.loader = false;
        return false;
      }
      //this.loadermessage = "Saving the Data!";
      this.service.CreateSuppMasterPassengerCriteria(this.supplierPassengerCriteria).subscribe((data) => {
        if (data) {
          this.messageservice.add({ severity: 'success', summary: 'Success', detail: 'Created Successfully!' });
          this.router.navigateByUrl("/MasterSupplierPassengerlist");
        }
        else {
          this.messageservice.add({ severity: 'error', summary: 'Error', detail: "Something went wrong" });
        }
        this.loader = false;
      })
    }

  }

  //sectorchange(airline: number, sector: number, type: number) {
  //  if (type == this.rateofexhcnageenum.locationInclusion) {
  //    if (!this.supplierPassengerCriteria.byAirlines[airline].bySectorList[sector].isLocationInclusuion) {
  //      this.supplierPassengerCriteria.byAirlines[airline].bySectorList[sector].locationInclusuion = new LocationByROE();
  //    }
  //  }
  //  else if (type == this.rateofexhcnageenum.locationExclusion) {
  //    if (!this.supplierPassengerCriteria.byAirlines[airline].bySectorList[sector].isLocationExclusuion) {
  //      this.supplierPassengerCriteria.byAirlines[airline].bySectorList[sector].locationExclusuion = new LocationByROE();
  //    }
  //  }
  //  else if (type == this.rateofexhcnageenum.bookingDate) {
  //    if (!this.supplierPassengerCriteria.byAirlines[airline].bySectorList[sector].isBookingDate) {
  //      this.supplierPassengerCriteria.byAirlines[airline].bySectorList[sector].bookingDate = new ROEDates();
  //    }
  //  }
  //  else if (type == this.rateofexhcnageenum.travllingDate) {
  //    if (!this.supplierPassengerCriteria.byAirlines[airline].bySectorList[sector].isTravelDate) {
  //      this.supplierPassengerCriteria.byAirlines[airline].bySectorList[sector].travelingDate = new ROEDates();
  //    }
  //  }
  //  else if (type == this.rateofexhcnageenum.tripType) {
  //    if (!this.supplierPassengerCriteria.byAirlines[airline].bySectorList[sector].isTripType) {
  //      this.supplierPassengerCriteria.byAirlines[airline].bySectorList[sector].tripTypes = new TripType();
  //    }
  //  }

  //}

  airlinesCheckIfExisit(index: number) {
    for (let o = 0; o < this.supplierPassengerCriteria.byAirlines.length; o++) {
      if (o !== index && !this.supplierPassengerCriteria.byAirlines[o].isDeleted) {
        const otherAirlines = this.supplierPassengerCriteria.byAirlines[o].airlines;
        const selectedAirlines = this.supplierPassengerCriteria.byAirlines[index].airlines;
        if (Array.isArray(otherAirlines) && otherAirlines.every(airline => typeof airline === 'string')) {
          for (let i = 0; i < selectedAirlines.length; i++) {
            const selectedAirline = selectedAirlines[i];
            if (otherAirlines.includes(selectedAirline)) {
              selectedAirlines.splice(i, 1);
              i--;
              this.messageservice.add({ severity: 'warn', summary: 'Warning', detail: "Airline Already Selected!" });
            }
          }
        }
      }
    }

  }

  ChecktheCriteriaExistOrNot(): boolean {

    const index = this.supplierPassengerCriteriaExisitINdb.findIndex(rt =>
      rt.supplier === this.supplierPassengerCriteria.supplier);

    if (index !== -1) {
      this.messageservice.add({ severity: 'warn', summary: 'Warning', detail: "Against This Supplier, a Passenger Criteria already Exists!.The Criteria Name is: " + this.supplierPassengerCriteriaExisitINdb[index].name });
      return false;
    }
    else {
      return true;
    }
  }

  //onROEChange(value: number): boolean {

  //  let check = false;
  //  if (this.currency === 'AED') {
  //    if (value >= 1) {

  //      this.messageservice.add({ severity: 'error', summary: 'Error', detail: 'Enter value less than 1' });
  //      check = false;
  //    } else {
  //      check = true;

  //    }
  //    return check;
  //  }
  //  else if (this.currency === 'PKR') {
  //    if (value <= 1) {
  //      this.messageservice.add({ severity: 'error', summary: 'Error', detail: 'Enter value that greater than 1.' });
  //      check = false;
  //    } else {
  //      check = true;

  //    }

  //  }
  //  return check;
  //}

  //rateOfExchangeRoeCheck(value: number): boolean {
  //  let check = false;
  //  if (!this.onROEChange(value)) {
  //    document.getElementById("rateofexchangeobjroe").innerHTML = "**Invalid Value.";
  //    check = false;

  //  }
  //  else {
  //    document.getElementById("rateofexchangeobjroe").innerHTML = "";
  //    check = true;

  //  }
  //  return check;
  //}

  //airlineRoeCheck(value: number, a: number) {
  //  let check = false;
  //  if (!this.onROEChange(value)) {
  //    document.getElementById(`airlineroecheck${a}`).innerHTML = "**Invalid Value.";
  //    check = false;
  //  }
  //  else {
  //    document.getElementById(`airlineroecheck${a}`).innerHTML = "";
  //    check = true;
  //  }
  //  return check;
  //}
  //sectorRoeCheck(value: number, a: number, s: number) {
  //  let check = false;
  //  if (!this.onROEChange(value)) {
  //    document.getElementById(`sectorroecheck${a}${s}`).innerHTML = "**Invalid Value.";
  //    check = false;
  //  }
  //  else {
  //    document.getElementById(`sectorroecheck${a}${s}`).innerHTML = "";
  //    check = true;
  //  }
  //  return check;
  //}

  //validatePositiveNumber(event: any) {
  //  const value = event.target.value;
  //  if (value < 0) {
  //    event.target.value = '';
  //    this.messageservice.add({ severity: 'error', summary: 'Error', detail: 'Enter positive number.' });
  //  }
  //}
}
